import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { pageViewEvent } from '@holmescorp/analytics';
import LoadingIndicator from '@dojo/widgets/loading-indicator';
import { svc } from '../support/svc';
import { Toolbar } from './toolbar';
import { nls } from '../support/glossary-nls';
import css from '../css/glossary.m.css';
const icache = createICacheMiddleware();
const factory = create({ icache, theme, nls }).properties();
export const Glossary = factory(({ middleware: { icache, theme, nls }, properties }) => {
    const { isPlaceholder, messages: { glossary_url, instructions = '' } } = nls();
    const { loadall = false } = properties();
    if (isPlaceholder) {
        return null;
    }
    const pushPageView = icache.getOrSet('pushPageView', true);
    const doPushPageView = () => {
        pageViewEvent('glossary', `${location.href}/glossary`, `${location.pathname}/glossary`);
        icache.set('pushPageView', false);
    };
    const usedletters = icache.getOrSet('usedletters', async () => {
        svc._smd.url = `${window.hcstatic.portal_url}/${glossary_url}`;
        const used = await svc.used_letters();
        return used;
    });
    const themedCss = theme.classes(css);
    const searchResults = (terms) => {
        return terms
            .map((term, idx) => {
            return [
                v('dt', {
                    key: `term-${idx}`,
                    role: 'heading',
                    ...formatAriaProperties({ level: '1' }),
                    classes: [themedCss.term],
                    innerHTML: term.term
                }),
                v('dd', { key: `def-${idx}`, classes: [themedCss.definition], innerHTML: term.definition })
            ];
        })
            .flat();
    };
    const select_letter = async (ltr) => {
        const terms = await svc.search_letter({ search_char: [ltr] });
        const kids = searchResults(terms);
        icache.set('selected', ltr);
        icache.set('selectedkids', kids);
    };
    const do_search = async (search) => {
        const terms = await svc.search_text({ search });
        const kids = searchResults(terms);
        icache.set('selected', '');
        icache.set('selectedkids', kids);
    };
    const selected = icache.get('selected');
    const selectedkids = icache.get('selectedkids');
    const displayTerms = selectedkids !== undefined;
    const element = displayTerms ? 'dl' : 'div';
    pushPageView && doPushPageView();
    if (loadall && !icache.get('selectedkids')) {
        do_search('');
        return w(LoadingIndicator, {});
    }
    return v('div', {
        classes: [theme.variant(), themedCss.root]
    }, [
        usedletters ? w(Toolbar, { usedletters, selected, themedCss, select_letter, do_search }) : null,
        v(element, { classes: [displayTerms ? themedCss.terms : null] }, displayTerms ? selectedkids : [instructions])
    ]);
});
